import {
  GET_FLEXIBLE_OPTIONS,
  GET_FLEXIBLE_OPTIONS_SUCCESS,
  GET_FLEXIBLE_OPTIONS_FAILURE,
} from '../actions/flexibleOptions';

const INITIAL_STATE = { loading: true, cached: false };

export default function flexibleOptionsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_FLEXIBLE_OPTIONS:
      return {
        ...state,
        loading: true,
        cached: true,
      };
    case GET_FLEXIBLE_OPTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        flexiblePaymentOptions: (action.payload && action.payload.flexiblePaymentOptions) || [],
      };
    case GET_FLEXIBLE_OPTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        cached: false,
        error: true,
      };
    default:
      return state;
  }
}
